import Select from "components/shared/select";
import React from "react";
import { list } from "sources/books/employees";

const ResponsibleFilter = (props) => {
    const selectProps = {
        placeholder: "Ответственный",
        onChange: props.setFilter,
        url: list,
        value: props.values.responsibleId,
        inputProps: { name: "responsibleId" },
        propName: "fullNameOrEmail",
        className: "report__filters--control",
    };
    return (
        <div className="mb-md-0 report__filters--mr">
            <Select {...selectProps} />
        </div>
    );
};

export default ResponsibleFilter;
